import React from 'react';
import {useIntl} from 'react-intl';

import messages from './messages';

import styles from './FooterCopyright.module.scss';

const FooterCopyright = () => {
	const intl = useIntl();
	const currentYear = new Date().getFullYear();

	return (
		<div className={styles['footer__copyright']}>
			{intl.formatMessage(messages.copyright, {year: currentYear})}
		</div>
	);
};

export default FooterCopyright;
